export default __webpack_public_path__ + "images/aa9b5d0b26e20b510705c34dc1638a30.svg";